export const questionConvertor = (paragraphs: string[]) => {
    
    let store = []
    let elem:string[] = []

    paragraphs.forEach((e)=>{
        if (e == " " && elem.length != 0){
            store.push(elem)
            elem = []
        }else{
            elem.push(e)
        }
    })

    if (elem.length != 0){
        store.push(elem)
    }

    let final_store: any = []

    store.forEach((each)=>{
        if (each.length == 1 && each[0]==' '){
            return;
        }
        let cont: any = {}
        let ques = ''
        let where = 'question'
        each.forEach((el)=>{
            if (el.startsWith('A.')){
                cont['choice_a'] = el.slice(2,).trimStart().trimEnd()
                where = 'choice_a'
            }else if (el.startsWith('B.')){
                cont['choice_b'] = el.slice(2,).trimStart().trimEnd()
                where = 'choice_b'
            }else if (el.startsWith('C.')){
                cont['choice_c'] = el.slice(2,).trimStart().trimEnd()
                where = 'choice_c'
            }else if (el.startsWith('D.')){
                cont['choice_d'] = el.slice(2,).trimStart().trimEnd()
                where = 'choice_d'
            }else if (el.startsWith('Answer:')){
                cont['answer'] = el.slice(7,).trimStart().trimEnd()
            }else{
                if(where=='question') {
                    ques += el
                } else {
                    cont[where] = cont[where] + el
                }
            }
        })
        
        cont['question'] = ques

        if (Object.keys(cont).includes('question') && Object.keys(cont).includes('choice_a') && Object.keys(cont).includes('choice_b') && Object.keys(cont).includes('choice_c') && Object.keys(cont).includes('choice_d') && Object.keys(cont).includes('answer')){
            if (cont['question'] != '' && cont['choice_a'] != '' && cont['choice_b'] != '' && cont['choice_c'] != '' && cont['choice_d'] != '' && cont['answer'] != ''){
                final_store.push(cont)
            }
        }


    })

    return final_store

}